"use client";

import type { SignupStep } from "@/hooks/useSignupFunnel";
import { useSearchParams } from "next/navigation";

export const SIGNUP_RESUME_PARAM = "signup";

/**
 * Steps the funnel may be reopened at from the URL. The verify route redirects
 * back with `?signup=select-attendee` after email verification (DIS-1117);
 * every other step is only reachable from inside the funnel.
 */
const RESUMABLE_SIGNUP_STEPS: readonly SignupStep[] = ["select-attendee"];

/**
 * The signup step to reopen the funnel at, from `?signup=`. Read in the browser
 * rather than from server `searchParams`: the event page's HTML is cached, so a
 * server read comes back empty and the funnel never reopens.
 */
export function useSignupResumeStep(): SignupStep | undefined {
  const requested = useSearchParams()?.get(SIGNUP_RESUME_PARAM);
  return RESUMABLE_SIGNUP_STEPS.find((step) => step === requested);
}
